import { PortableText } from '@portabletext/react';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { ChevronLeft, ChevronRight } from 'react-feather';
import imgFallback from 'src/utils/image';

const NAVIGATION_ITEMS = [
  { icon: <ChevronLeft size={20} />, direction: 'prev' },
  { icon: <ChevronRight size={20} />, direction: 'next' },
];

function TabItem({ id, content, handleNavigation, totalTabs, noNavigation }) {
  return (
    <Col xs={12} className="px-0">
      <Row noGutters className="mt-5">
        <Col xs={12} lg={6} className="align-self-start">
          <Col xs={12} className="d-flex justify-content-end px-0">
            <GatsbyImage alt={content?.image?.alt ?? ''} image={content?.image?.image?.asset?.gatsbyImageData ?? imgFallback} />
          </Col>
        </Col>
        <Col xs={12} lg={6} className="align-self-center px-md-5 pl-md-6 px-2 py-5 pl-0">
          <Row>
            {content.title && (
              <Col xs={12} as="h4">
                {content.title}
              </Col>
            )}
            <Col xs={12} className="text-muted mt-3 p-0">
              <PortableText value={content.description} />
            </Col>
            {content.links?.length > 0 && (
              <Col>
                <Row style={{ gap: '1rem' }}>
                  {content.links.map((link) => (
                    <Link key={link._key} _key={link._key} to={link.url} className="btn-link-tertiary text-uppercase mt-3">
                      {link.title}
                    </Link>
                  ))}
                </Row>
              </Col>
            )}
            {!noNavigation && (
              <Col xs={12} className="mt-5">
                <Row className="align-items-center">
                  {NAVIGATION_ITEMS.map((navigationItem) => (
                    <Col key={navigationItem.direction} xs="auto">
                      <button
                        type="button"
                        className="btn min-w-none text-purple rounded-circle d-flex bg-white p-3 transition-colors"
                        style={{
                          outline: '2px solid currentColor',
                        }}
                        name={navigationItem.direction}
                        onClick={() => handleNavigation(navigationItem.direction)}
                      >
                        {navigationItem.icon}
                      </button>
                    </Col>
                  ))}
                  <Col xs="auto" className="badge badge-light badge-pill ml-auto p-3">{`${id + 1} / ${totalTabs}`}</Col>
                </Row>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </Col>
  );
}

TabItem.propTypes = {
  id: PropTypes.number.isRequired,
  content: PropTypes.shape({
    subTitle: PropTypes.string,
    description: PropTypes.arrayOf(PropTypes.shape({})),
    image: PropTypes.shape({}),
    links: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  totalTabs: PropTypes.number.isRequired,
  noNavigation: PropTypes.bool,
  handleNavigation: PropTypes.func,
};

TabItem.defaultProps = {
  noNavigation: false,
  handleNavigation: () => {},
};

export default TabItem;
